import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisabledInputComponent } from './disabled-input.component';
import { RsCopyModule } from '../../../../../../../libs/rs-copy/src/index';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
    declarations: [DisabledInputComponent],
    exports: [DisabledInputComponent],
    imports: [CommonModule, RsCopyModule, MatFormFieldModule]
})
export class DisabledInputModule {}
